import styled from "styled-components";

export const Title = styled.h1 `
    position: absolute;
    top: 0;
    right: 300px;
    color: white;
    font-size: 3rem;
    filter: drop-shadow(0 0 0.5rem #7F00FF);
`